import React from 'react';

interface AreaFilterPopoverContentProps {
  areaRange: { min: string; max: string };
  onFilterChange: (field: string, value: any, applyImmediately?: boolean) => void;
}

export const AreaFilterPopoverContent: React.FC<AreaFilterPopoverContentProps> = ({
  areaRange,
  onFilterChange
}) => {
  return (
    <div className="space-y-4">
      <div className="grid grid-cols-2 gap-3">
        <div>
          <label className="block text-[11px] font-bold text-gray-500 uppercase tracking-wider mb-1.5">
            Desde
          </label>
          <div className="relative flex items-center">
            <input
              type="number"
              min="0"
              value={areaRange.min}
              onChange={(e) =>
                onFilterChange('areaRange', {
                  ...areaRange,
                  min: e.target.value
                })
              }
              className="w-full h-11 pl-3 pr-9 py-2 bg-white border border-gray-300 rounded-xl text-sm font-medium text-gray-800 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-sky-500/20 focus:border-sky-500 transition-all shadow-sm"
              placeholder="0"
            />
            <span className="absolute right-3 text-xs font-semibold text-gray-400 pointer-events-none">
              m²
            </span>
          </div>
        </div>

        <div>
          <label className="block text-[11px] font-bold text-gray-500 uppercase tracking-wider mb-1.5">
            Hasta
          </label>
          <div className="relative flex items-center">
            <input
              type="number"
              min="0"
              value={areaRange.max}
              onChange={(e) =>
                onFilterChange('areaRange', {
                  ...areaRange,
                  max: e.target.value
                })
              }
              className="w-full h-11 pl-3 pr-9 py-2 bg-white border border-gray-300 rounded-xl text-sm font-medium text-gray-800 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-sky-500/20 focus:border-sky-500 transition-all shadow-sm"
              placeholder="Sin límite"
            />
            <span className="absolute right-3 text-xs font-semibold text-gray-400 pointer-events-none">
              m²
            </span>
          </div>
        </div>
      </div>

      {(areaRange.min || areaRange.max) && (
        <div className="flex flex-wrap gap-2 pt-3 border-t border-gray-100">
          {areaRange.min && (
            <div className="flex items-center px-2.5 py-1 rounded-full border text-[11px] font-bold bg-blue-50 text-blue-700 border-blue-200 shadow-sm">
              <span>Mín: {areaRange.min} m²</span>
              <button
                type="button"
                onClick={() => onFilterChange('areaRange', { ...areaRange, min: '' }, true)}
                className="ml-1.5 p-0.5 hover:bg-blue-200 rounded-full transition-colors text-blue-600"
              >
                ✕
              </button>
            </div>
          )}
          {areaRange.max && (
            <div className="flex items-center px-2.5 py-1 rounded-full border text-[11px] font-bold bg-blue-50 text-blue-700 border-blue-200 shadow-sm">
              <span>Máx: {areaRange.max} m²</span>
              <button
                type="button"
                onClick={() => onFilterChange('areaRange', { ...areaRange, max: '' }, true)}
                className="ml-1.5 p-0.5 hover:bg-blue-200 rounded-full transition-colors text-blue-600"
              >
                ✕
              </button>
            </div>
          )}
        </div>
      )}
    </div>
  );
};
